import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import AboutUsContent from "../ones/AboutUsContent";
import PageWithSidebar from "../components/PageWithSidebar";
import PageHero from "../ones/PageHero";
import bgImage from "../assets/image10.jpeg";

export default function View(props) {
  const appContext = useContext(AppContext);

  const heroData = {
    bgImage: bgImage,
	kicker: "Kuhusu Sisi",
	title: "Muhutasari wa YCSC SACCOS",
	description: "Ushirika thabiti ulioundwa kwa misingi ya umoja, uwazi na maendeleo ya kiuchumi kwa wanachama wetu."
  };

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <PageHero bgImage={heroData.bgImage} kicker={heroData.kicker} heading={heroData.title} paragraph={heroData.description} />
        <PageWithSidebar>
          <AboutUsContent />
        </PageWithSidebar>
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
